import React, { FunctionComponent, useEffect, useState } from 'react';
import { Button, View } from '@upstox/upstox-ui';
import NextLink from 'next/link';
import * as css from './ActionButtons.style';
import { getOnboardingUrl, getSignInUrl } from '../../helpers';
import { ROUTES } from 'src/constants';

const ActionButtons: FunctionComponent = () => {
  const [onboardingUrl, setOnboardingUrl] = useState<string>(
    ROUTES.ONBOARDING_ROUTE,
  );
  useEffect(() => {
    setOnboardingUrl(getOnboardingUrl());
  }, []);
  return (
    <View css={css.wrapper} justifyContent="center" alignItems="center">
      <View css={css.openAccount}>
        <Button size="large" width="full" variant="secondary">
          <a
            href={onboardingUrl}
            style={{ color: 'inherit' }}
            className="full-width"
          >
            Open Account
          </a>
        </Button>
      </View>
      <View css={css.login}>
        <Button
          size="large"
          width="full"
          onClick={() => window.open(getSignInUrl(), '_self')}
        >
          Apply Now
        </Button>
      </View>
    </View>
  );
};

export default ActionButtons;
